export function onlyDigits(v) {
  return (v || "").toString().replace(/\D/g, "")
}

export function formatCpf(raw) {
  const d = onlyDigits(raw).slice(0, 11)
  if (d.length <= 3) return d
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}

// validação DV CPF (evita chamar SOA com CPF inválido)
export function isValidCpfDigits(cpf) {
  if (!cpf || cpf.length !== 11) return false
  if (/^(\d)\1{10}$/.test(cpf)) return false

  function calcDV(base, factor) {
    let sum = 0
    for (let i = 0; i < base.length; i++) sum += parseInt(base.charAt(i), 10) * (factor - i)
    const mod = (sum * 10) % 11
    return (mod === 10) ? 0 : mod
  }

  const dv1 = calcDV(cpf.slice(0, 9), 10)
  const dv2 = calcDV(cpf.slice(0, 10), 11)

  return dv1 === parseInt(cpf.charAt(9), 10) && dv2 === parseInt(cpf.charAt(10), 10)
}

export function formatIsoFromBrDate(dataString) {
  const partes = (dataString || "").split("/")
  if (partes.length !== 3) return null

  let [dia, mes, ano] = partes

  if (ano.length === 2) {
    ano = (parseInt(ano, 10) > 20) ? (`19${ano}`) : (`20${ano}`)
  }

  return `${ano}-${(`0${mes}`).slice(-2)}-${(`0${dia}`).slice(-2)}`
}
